import './sentry'; // Importa Sentry PRIMA di tutto
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './config/vite-env';
import { config } from './config/env';
import { ErrorFallback } from './components/ErrorFallback';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback
          error={
            error instanceof Error
              ? error
              : error
                ? new Error(String(error))
                : null
          }
          resetError={resetError}
        />
      )}
      showDialog={config.NODE_ENV === 'production'}
    >
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
